import React, { useState, useEffect } from 'react';
import MicroFrontend from '../microfrontend/microfrontend';
import Antares, { addKeydownEvent, altair, removeKeydownEvent } from 'antares';
import { getLocalConfig } from '../stores/app-store';
import './app.css';
import privacyStyle from '../views/federated-style/privacyStyle';
import privacyStyleExtended from '../views/federated-style/privacy-extended';
import surveyStyle from '../views/federated-style/surveyStyle';
import pj from '../../package.json'
import { useRef } from 'react';
import { currentChannelStore, getCurrentChannel } from '../stores/channel-store';

const App = (props) => {

  const [apps, setApps] = useState([])
  const [mainApp, setMainApp] = useState();
  const [surveyApp, setSurveyApp] = useState();
  const [privacyApp, setPrivacyApp] = useState();
  const [telemetryApp, setTelemetryApp] = useState();
  const [ready, setReady] = useState(false);
  const [showMain, setShowMain] = useState(false)
  const [showSurvey, setShowSurvey] = useState(false);
  const [callbackTrigger, setCallbackTrigger] = useState(false)
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [mainVersion, setMainVersion] = useState(null)
  const [privacyVersion, setPrivacyVersion] = useState(null)
  const [telemetryVersion, setTelemetryVersion] = useState(null)
  const [surveyVersion, setSurveyVersion] = useState(null)
  const [showVersion, setShowVersion] = useState(false)
  const showVersionRef = useRef(false)

  const activeTestButtons = useRef(false)

  let appSilente;
  let telemetryEnabled;
  let appName = "";
  let channels = null;
  let telemetry = null;
  let serialNumber = null;
  let minuteTecnicalCookie = null;
  let saveOldPrivacyData = false;

  const cookiesParse = () => {
    let _cookies = document.cookie;
    let response = [];
    let arr_cookies = [];

    if (_cookies.indexOf(";") > 0) {
        arr_cookies = _cookies.replace(/\s/g, "").split(";");
    } else {
        arr_cookies.push(_cookies.replace(/\s/g, ""));
    }
    console.log("@@ arr_cookies :", arr_cookies)
    arr_cookies && arr_cookies.map((a_cookie) => {

        let row = a_cookie.split("=")

        response.push({
            'key': row[0],
            'value': row[1]
        })
    });
    console.log("@@ response: ", response)
    return response;
  }

  const getExpires = (time = null) => {
    console.log("TIME EXPIRE BEFORE CHECK", time);
    if (time === null) {
        time = 396 * 24 * 60;
    }
    console.log("TIME EXPIRE AFTER CHECK", time);
    let d = new Date();
    console.log("CHECK TIME", { now: d.getTime(), time: time * 60 * 1000, after: d.getTime() + (time * 60 * 1000) });
    d.setTime(d.getTime() + (time * 60 * 1000));
    console.log("TIME UTC", d.toUTCString());
    let expires = "expires=" + d.toUTCString();
    return expires;
}

  const onAntaresLoaded = () => {
    getCurrentChannel()
      .then(() => {
        getLocalConfig()
          .then((res) => {
            showVersionRef.current = res.appVersion
            appSilente = res.silente;
            telemetryEnabled = res.telemetryEnabled
            let federatedApps = []
            if (apps.length === 0) {
              if (res.channels && res.channels.item) {
                channels = res.channels
                res.channels.item.forEach((element) => {
                  console.log("triplette", element, currentChannelStore.getState())
                  if (currentChannelStore.getState().channel.tsid === element.triplet.tsid
                    && currentChannelStore.getState().channel.onid === element.triplet.onid
                    && currentChannelStore.getState().channel.sid === element.triplet.sid) {
                    console.log("element.name", element.name)
                    appName = element.name;
                  }
                })
              }
              if(res.activeTestButtons){
                activeTestButtons.current = res.activeTestButtons
              }

              if(res.saveOldPrivacyData){
                saveOldPrivacyData = res.saveOldPrivacyData;
              }

              console.log("@@@ RES :", res)
              res.federated.map((app) => {
                if(app.minuteTecnicalCookie){
                  minuteTecnicalCookie = app.minuteTecnicalCookie
                }
              })
              res.federated.map((app) => {
                console.log("onAntaresLoaded", app, app?.privacyCookie,altair.storeManager.getItem(app.privacyCookie))

                if (app.privacyCookie) {
                  let privacyCookie = app.privacyCookie;
                  const _cookies = cookiesParse();
                  let stored = _cookies?.find((c) => String(c.key).replace(/\s/g, "") === privacyCookie);
                  stored = stored?.value;
                  console.log("COOKIE ACCEPTANCE", stored);
                  setShowPrivacy(stored === undefined ? true : false)
                }

                console.log("@@@ CHECK OLD PRIVACY :",saveOldPrivacyData, altair.storeManager.getItem(app?.privacyCookie), app?.privacyCookie)
                if(saveOldPrivacyData && altair.storeManager.getItem(app?.privacyCookie) !== null){
                  
                  const privacyAccepted = altair.storeManager.getItem(app?.privacyCookie);
                  const expiresTecnical = getExpires(app?.minuteTecnicalCookie)

                  if(privacyAccepted === "true"){
                      console.log("@@@ OLD PRIVACY ACCEPTED :", app?.managerPreferences)

                      const _managerPreferences = app?.managerPreferences
                      const _preferencesCookie = [];
                      document.cookie = `${app?.privacyCookie}=${privacyAccepted};${JSON.stringify(expiresTecnical)};path=/`;
                      setTimeout(() => {     
                          if(_managerPreferences 
                              && _managerPreferences.tr 
                              && _managerPreferences.tr.length >= 0){
                                  _managerPreferences.tr.forEach((elem) => {
                                      console.log("ELEM :", elem)
                                      if(elem.enable){
                                          _preferencesCookie.push({
                                              id: elem.id
                                          })
                                      }
                                  })
                              }

                          const COOKIE_PREFERENCES = 'cookie-preferences'

                          console.log("@@@ COOKIES : ACCEPTANCE : ", `${COOKIE_PREFERENCES}=${JSON.stringify(_preferencesCookie)};${JSON.stringify(expiresTecnical)};path=/`);
                          document.cookie = `${COOKIE_PREFERENCES}=${JSON.stringify(_preferencesCookie)};${JSON.stringify(expiresTecnical)};path=/`;
                          const playerMonitor = window.PlayerMonitor.getInstance();
                          console.log('@@ PLAYER MONITOR :', playerMonitor)


                          if(_managerPreferences 
                              && _managerPreferences.tr 
                              && _managerPreferences.tr.length > 0 && playerMonitor){
                                  _managerPreferences.tr.forEach(elem => {
                                  console.log("@@ ELEM EVENT :", elem, playerMonitor)
                                  if (elem.type === "technical") {
                                      playerMonitor.customEvent("COOKIE_TECNICO_ACCEPTED");
                                  }
                                  if (elem.type === "analytics-internal") {
                                      playerMonitor.customEvent("COOKIE_ANALITICO_I_ACCEPTED");
                                  }
                                  if (elem.type === "analytics-external") {
                                      playerMonitor.customEvent("COOKIE_ANALITICO_III_ACCEPTED");
                                  }
                                  if (elem.type === "profiling") {
                                      playerMonitor.customEvent("PROFILAZIONE_ACCEPTED");
                                  }
                              })
                          }
                          console.log("@@@ PRIVACY COOKIE :", app)

                          playerMonitor.emptyQueueExpress && playerMonitor.emptyQueueExpress();
                          localStorage.removeItem(app?.privacyCookie)
                      },2750)

                      setShowPrivacy(false)
                  }
                  if(privacyAccepted === "false"){
                      console.log("@@@ OLD PRIVACY REFUSED")
                      document.cookie = `${app?.privacyCookie}=${privacyAccepted};${JSON.stringify(expiresTecnical)};path=/`;
                      localStorage.removeItem(app?.privacyCookie)
                      setShowPrivacy(true)
                  }

                }
                if (app.telemetry) {
                  console.log("@@@ APP TELEMETRY :", app.telemetry)
                  telemetry = app.telemetry
                  serialNumber = app?.telemetry?.serialNumber
                  window.use_cookie = true
                }
                if (appName !== "") {
                  telemetry.appName = appName
                }
                if (app.enable) {
                  console.log("@@@ APP :", app)
                  federatedApps.push(
                    <MicroFrontend
                      host={app.host}
                      name={app.name}
                      button={app.button}
                      telemetryEvent={app.telemetryEvent}
                      type={app.type}
                      enable={app.enable}
                      properties={{
                        hostname: app.host,
                        setShowMain: setShowMain,
                        width: 1920,
                        height: 1080,
                        federated: true,
                        survey: {
                          fullScreen: true,
                          setSurveyVersion: setSurveyVersion,
                          setShowSurvey: setShowSurvey,
                          info: app.survey,
                          isContent: false,
                          style: surveyStyle,
                          nItems: 6,
                          trigger: {
                            triggerMinimized: false,
                            showTime: app.survey && app.survey.trigger && app.survey.trigger.triggerShowTime ? app.survey.trigger.triggerShowTime : 1,
                            hideTime: app.survey && app.survey.trigger && app.survey.trigger.triggerHideTime ? app.survey.trigger.triggerHideTime : null,
                            button: app.survey && app.survey.trigger && app.survey.trigger.button ? app.survey.trigger.button : null,
                            telemetryEvent: app.survey && app.survey.trigger && app.survey.trigger.telemetryEvent ? app.survey.trigger.telemetryEvent : null,
                            enable: app.survey && app.survey.trigger && app.survey.trigger.enable ? app.survey.trigger.enable : null,
                            setCallbackTrigger: setCallbackTrigger
                          },
                        },
                        privacy: {
                          setPrivacyVersion: setPrivacyVersion,
                          setShowPrivacy: setShowPrivacy,
                          telemetryEnabled: true,
                          base_title: app.privacyBaseTitle,
                          base_text: app.privacyBaseText,                              
                          info_title: app.privacyInfoTitle,
                          info_text: app.privacyInfoText,
                          manager_preferences: app.managerPreferences,
                          preventUpKeydownBase: app.preventUpKeydownBase,
                          preventUpKeydownInfo: app.preventUpKeydownInfo,
                          firstTimeInFocus: app.firstTimeInFocus,
                          orderButtonsLevel0: app.orderButtonsLevel0,
                          orderButtonsLevel1: app.orderButtonsLevel1,
                          orderButtonsLevelManager: app.orderButtonsLevelManager,
                          cookie: app.privacyCookie,
                          xButton: app.xButton,
                          nameTestCookiexButton: app.nameTestCookiexButton,
                          nameTestCookieRefuseButton: app.nameTestCookieRefuseButton,
                          minuteRefuseCookie: app.minuteRefuseCookie,
                          minuteAcceptedCookie: app.minuteAcceptedCookie,
                          minuteTecnicalCookie: app.minuteTecnicalCookie,
                          poweredByKineton: app.poweredByKineton,
                          extended: app.extended,
                          style: app.extended ? privacyStyleExtended : privacyStyle,
                          serialNumber: serialNumber,
                          column: true,
                          federated: true,
                          saveOldPrivacyData: saveOldPrivacyData,
                          enabledShowUuid: app.enabledShowUuid
                        },
                        mainApp: {
                          setMainVersion: setMainVersion,
                          setShowMain: setShowMain,
                          utils: app.utils
                        },
                        telemetry: {
                          setTelemetryVersion: setTelemetryVersion,
                          enabled: telemetryEnabled,
                          info: telemetry,
                          saveOldPrivacyData: saveOldPrivacyData,
                          minuteTecnicalCookie : minuteTecnicalCookie
                        }
                      }}
                      key={`app-${app.name}`}
                    />
                  )
                }
              })
              setApps(federatedApps)
              if (federatedApps) {
                federatedApps.map((app) => {
                  console.log("apps", app)
                  if (app.props.type === "MainApp") {
                    setMainApp(app)
                  }
                  else if (app.props.type === "SurveyApp") {
                    setSurveyApp(app)
                  }
                  else if (app.props.type === "PrivacyApp") {
                    setPrivacyApp(app)
                  }
                  else if (app.props.type === "TelemetryApp") {
                    setTelemetryApp(app)
                  }
                })
                setReady(true)
              }
            }
          })
      })
  }

  useEffect(() => {
    setShowVersion(showVersionRef.current)
  }, [showVersionRef.current])

  useEffect(() => {
    if (!showSurvey) {
      console.log("kill-survey")
      const killEvent = new CustomEvent('KILL_SURVEY', { detail: true });
      window.dispatchEvent(killEvent)
    }
  }, [showSurvey])

  useEffect(() => {
    if (!showMain) {
      console.log("kill-main")
      const killEvent = new CustomEvent('KILL_MAIN', { detail: true });
      window.dispatchEvent(killEvent)
    }
  }, [showMain])

  useEffect(() => {
    if (showPrivacy) {
      setShowSurvey(false)
      setShowMain(false)
      const killEvent = new CustomEvent('KILL_MAIN', { detail: true });
      window.dispatchEvent(killEvent)
      const killEvent2 = new CustomEvent('KILL_SURVEY', { detail: true });
      window.dispatchEvent(killEvent2)
    }
    else {
      setShowSurvey(true)
      setShowMain(true)
    }
  }, [showPrivacy])

  const onKeyDownHandler = (e) =>{
    console.log("@@ ACTIVE TEST BUTTONS :", activeTestButtons.current)
    if(activeTestButtons.current){
      if(e.keyCode === 404 || e.keyCode === 71){
          deleteAllCookie()
          localStorage.setItem('kisskiss-privacy-acceptance', "false")
          localStorage.setItem('kisskiss-serial-number', '456')
      }

      if(e.keyCode === 405 || e.keyCode === 89){
          deleteAllCookie()
          localStorage.setItem('kisskiss-privacy-acceptance', "true")
          localStorage.setItem('kisskiss-serial-number', '123')
      }
    }
  }

  const deleteAllCookie = () => {
    console.log("@@ DELETE ALL COOKIE")

    const cookies = document.cookie.split(";");
    cookies.forEach((cookie) => {
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
        console.log("@@ COOKIE NAME :", name)
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/"
    })
  }

  useEffect(() => {
    addKeydownEvent(onKeyDownHandler);
  },[])


  return (
    <Antares throttle={500} onAntaresLoaded={onAntaresLoaded}>
      {ready ?
        <div className='container-federated-apps'>
          {showVersion ?
            <div style={{ backgroundColor: 'black', position: 'absolute', top: "60px", right: "60px", display: "flex", alignItems: "center", justifyContent: "center", width: "400px", height: "400px", color: "white", fontSize: '30px', flexDirection: "column", fontWeight: 'bold', zIndex: 9999 }}>
              <span>Version Container: {pj.version}</span>
              <span>Version MainApp: {mainVersion}</span>
              <span>Version PrivacyApp: {privacyVersion}</span>
              <span>Version TelemetryApp: {telemetryVersion}</span>
              <span>Version SurveyApp: {surveyVersion}</span>
            </div>
            : null}
          {telemetryApp}
          {showPrivacy ? privacyApp : null}
          {appSilente ? null :
            <div>
              {mainApp && showMain ? mainApp : null}
              {surveyApp && showSurvey ? surveyApp : null}
            </div>
          }
        </div>
        : null}
    </Antares>
  )
};

export default App;
